import * as React from 'react';
import CreatePasswordForm from '@App/components/forms/CreatePasswordForm';
import { Title } from 'relevant-ui';

class ResetPasswordPage extends React.Component<any, any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      width: window.innerWidth,
      height: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = (event: Object) => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }

  render() {
    const { width } = this.state;

    return (
      <div className="loginPage">
        <div className="loginPage__wrapper">
          <Title
            title="Récupération du mot de passe."
            subtitle="Entrez et confirmez ci-dessous votre nouveau mot de passe."
            color={width <= 991 ? 'white' : 'black'}
          />
          <CreatePasswordForm
            isResetPassword={true}
          />
        </div>
      </div>
    );
  }
}

export default ResetPasswordPage;
